import { useEffect } from "react";

export const useDocumentTitle = (subdomain) => {
  
  useEffect(() => {
    document.title = subdomain;
  },[subdomain]);

};
